export const routes = {
  sources: {
    main: '/streams',
    lunaStreams: {
      streams: {
        main: '/streams',
        view: '/streams/:streamId',
        create: '/streams/create',
        edit: '/streams/:streamId/edit',
      },
      groups: {
        main: '/groups',
        view: '/groups/:groupId',
        create: '/groups/create',
        edit: '/groups/:groupId/edit',
      },
      queue: {
        main: '/queue',
      },
      logs: {
        main: '/logs',
      },
    },
  },
};
